/* Touchwake v2: offer box (prices from data-price cents, cart via /cart/add.js items), gallery (one group of slides per
   offer choice: band / shaker / bundle; the groups not selected are [hidden]), sticky bars.
   Same file in the mockups and in Shopify (assets/tw2.js). Accordions are native <details>. No dependencies. */
(()=>{
const $=(s,c=document)=>c.querySelector(s),$$=(s,c=document)=>[...c.querySelectorAll(s)];
const money=c=>'$'+(c/100).toFixed(c%100?2:0);
// gal(k): show group k (a switch opens on slide 1). gal(k,j): also go to the slide flagged data-jump=j (none = slide 1).
let gal=()=>{};
const g=$('[data-gal]');
if(g){
  const t=$('.gal__track',g),n=$('.gal__count b',g),m=$('[data-gal-n]',g),th=$('.gal__thumbs',g);
  let cur='band',S=$$('.gal__slide:not([hidden])',t);
  const at=()=>Math.round(t.scrollLeft/t.clientWidth);
  const go=(i,smooth)=>{if(smooth)return t.scrollTo({left:i*t.clientWidth,behavior:'smooth'});t.style.scrollBehavior='auto';t.scrollLeft=i*t.clientWidth;t.style.scrollBehavior=''};
  const mark=()=>{const i=at();$$('[data-i]',g).forEach(x=>x.setAttribute('aria-current',+x.dataset.i===i));if(n)n.textContent=i+1;
    const c=$('.gal__thumb[aria-current=true]:not([hidden])',g);if(c)th.scrollLeft=c.offsetLeft-(th.clientWidth-c.offsetWidth)/2};
  const home=()=>{go(0);mark()};home();addEventListener('pageshow',home);
  gal=(k,j)=>{
    const sw=k!==cur&&!!$('.gal__slide[data-g='+k+']',t);
    if(sw){cur=k;$$('[data-g]',g).forEach(x=>x.hidden=x.dataset.g!==k);S=$$('.gal__slide:not([hidden])',t);if(m)m.textContent=S.length;
      $$('.gal__thumb[data-g='+k+'] img',g).forEach(i=>i.loading='eager')}   // the set now showing: fetch all its thumbnails at once
    if(sw||j!=null){go(Math.max(0,S.findIndex(x=>j&&x.dataset.jump===j)),!sw);mark()}
  };
  t.addEventListener('scroll',()=>requestAnimationFrame(mark),{passive:true});
  $$('[data-i]',g).forEach(x=>x.addEventListener('click',()=>go(+x.dataset.i,1)));
  $$('[data-dir]',g).forEach(b=>b.addEventListener('click',()=>go((at()+ +b.dataset.dir+S.length)%S.length,1)));
}
const f=$('form[data-offer]')||$('#tw-buy');
if(f&&f.elements.choice){
  const E=f.elements,find=(n,v)=>$$('[name='+n+']',f).find(x=>x.value===v);
  const pick=()=>{const c=E.choice.value,el=c==='band'?find('qty',E.qty.value):find('choice',c);
    return{c,p:+el.dataset.price,ids:el.dataset.variant.split(',')}};
  const upd=()=>{
    const{c,p,ids}=pick(),two=E.qty.value==='2';
    const n=c==='band'?(two?'2 bands':'1 band'):c==='shaker'?'Touchwake Shaker':'Band + Shaker';
    $$('[data-buy-label]').forEach(e=>e.textContent='Add to cart · '+money(p));
    $$('[data-pick-name]').forEach(e=>e.textContent=n+' · '+money(p));
    $$('[data-band-price]').forEach(e=>e.textContent=money(+find('qty',E.qty.value).dataset.price));
    $$('[data-was]').forEach(e=>e.hidden=!two);
    // the Band card shows what is picked: one band on a wrist + the 1-band line, or the two-band photo + the 2-bands line
    $$('[data-band-thumb]',f).forEach(e=>e.hidden=(e.dataset.bandThumb==='2')!==two);
    $$('[data-band-desc]',f).forEach(e=>e.textContent=two?e.dataset.d2:e.dataset.d1);
    $$('[data-pay]').forEach(e=>e.hidden=c==='bundle');
    const id=$('[data-id-input]',f);if(id)id.value=ids[0];
    $$('.opt',f).forEach(o=>o.classList.toggle('is-on',o.querySelector('input').checked));
    gal(c);
  };
  // a shopper's pick shows that option's photo: its group, on the slide flagged for it (2 bands -> data-jump="band2"), else slide 1
  const show=()=>{const c=E.choice.value;gal(c,c==='band'?'band'+E.qty.value:c)};
  f.addEventListener('change',e=>{const k=e.target.name;if(k!=='qty'&&k!=='choice')return;if(k==='qty')E.choice.value='band';if(e.isTrusted)show();upd()});
  // the 1 / 2 toggle that is already checked fires no change: a tap on it still has to bring the Band choice back
  f.addEventListener('click',e=>{if(e.target.name==='qty'&&E.choice.value!=='band'){E.choice.value='band';show();upd()}});
  f.addEventListener('submit',e=>{
    e.preventDefault();
    if(!/\/cart\/add/.test(f.getAttribute('action')||''))return;
    const b=$('[data-buy-btn]',f);if(b)b.disabled=true;
    const root=(window.Shopify&&Shopify.routes&&Shopify.routes.root)||'/';
    fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},
      body:JSON.stringify({items:pick().ids.map(id=>({id:+id,quantity:1}))})})
      .then(r=>{if(!r.ok)throw 0;location.href=root+'checkout'})
      .catch(()=>{location.href=root+'cart/'+pick().ids.map(i=>i+':1').join(',')});
  });
  $$('[data-pick]').forEach(b=>b.addEventListener('click',e=>{e.preventDefault();let v=b.dataset.pick;
    if(v.startsWith('band')){find('qty',v.slice(4)).checked=true;v='band'}E.choice.value=v;show();upd();
    f.scrollIntoView({behavior:'smooth',block:'start'})}));
  const u=new URLSearchParams(location.search),ch=u.get('choice'),vr=u.get('variant');
  if(ch==='shaker'||ch==='bundle')E.choice.value=ch;
  else if(vr){const q=$$('[name=qty]',f).find(x=>x.dataset.variant===vr);if(q){q.checked=true;E.choice.value='band'}}
  upd();addEventListener('pageshow',upd);
}
const bar=(sel,watch,load)=>{
  const b=$(sel),w=$$(watch);if(!b||!w.length||!('IntersectionObserver'in window))return;
  const s=new Map(),io=new IntersectionObserver(es=>{
    es.forEach(e=>s.set(e.target,e.isIntersecting?0:e.boundingClientRect.top<0?-1:1));
    const v=[...s.values()];b.classList.toggle('is-on',!v.includes(0)&&(load||v.includes(-1)));
  });
  w.forEach(x=>io.observe(x));
};
bar('.sbar','[data-buy-btn]',1);
bar('.scta','[data-hero],[data-cta-inline]');
})();
